import * as React from 'react'
import { useState } from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { ExplotableItem, ExplotableList } from 'modules/core/components/GroupingExplotable'
import { useCallback } from 'modules/core/hooks/useCallback'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'

import GroupBody from './_GroupBody'

interface Group {
  id: number
  name: string
  count: number
  employees: Employee[]
}
interface Props {
  canBulkEdit: boolean
  items: Group[]
  selectedEmployeesIds: number[]
  onSelectEmployee: (employee: Employee, value: boolean) => void
  contractVersions: ContractVersions
}

type CategoriesState = Record<number, boolean>

const initializeCategoriesState = (items: Group[]) =>
  items.reduce<CategoriesState>((stateMap, category) => {
    stateMap[category.id] = false

    return stateMap
  }, {})

const GroupsList = ({
  canBulkEdit,
  items,
  selectedEmployeesIds,
  onSelectEmployee,
  contractVersions,
}: Props) => {
  const [categoriesOpenState, setCategoriesOpenState] = useState(initializeCategoriesState(items))

  const setCategoryState = useCallback(
    (category: Group, state: boolean) => () =>
      setCategoriesOpenState((prevState) => ({ ...prevState, [category.id]: state })),
    []
  )

  return (
    <ExplotableList>
      {items.map((category) => {
        if (category.count > 0) {
          const isCategoryOpen = categoriesOpenState[category.id] || false

          return (
            <ExplotableItem
              key={category.id}
              bottomRadius={false}
              dropDownAnimated={false}
              expandIcon="caret"
              headerBorders={false}
              headerRounded={false}
              opened={isCategoryOpen}
              renderHeader={() => (
                <Text.Normal size="200" weight="medium" color="grey800">
                  {`${category.name} (${category.count})`}
                </Text.Normal>
              )}
              scrollLimited={false}
              size="small"
              toggle={setCategoryState(category, !isCategoryOpen)}
              type="primary"
            >
              <GroupBody
                canBulkEdit={canBulkEdit}
                employees={category.employees}
                selectedEmployeesIds={selectedEmployeesIds}
                onSelectEmployee={onSelectEmployee}
                contractVersions={contractVersions}
              />
            </ExplotableItem>
          )
        }
      })}
    </ExplotableList>
  )
}

export default GroupsList
